"use client";

import { useState } from "react";
import { Save } from "lucide-react";
import { useCommsPanel } from "../CommsProvider";

interface NoteComposerProps {
  onSent: () => void;
}

export function NoteComposer({ onSent }: NoteComposerProps) {
  const { activeLeadId } = useCommsPanel();
  const [body, setBody] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    if (!body.trim() || !activeLeadId || saving) return;
    setSaving(true);
    try {
      await fetch(`/api/leads/${activeLeadId}/timeline/note`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ body: body.trim() }),
      });
      setBody("");
      onSent();
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="border-t border-gray-200 bg-white px-3 py-3">
      <p className="mb-2 text-xs font-medium text-yellow-700">Add Internal Note</p>
      <textarea
        value={body}
        onChange={(e) => setBody(e.target.value)}
        rows={3}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm resize-none focus:border-yellow-500 focus:outline-none focus:ring-1 focus:ring-yellow-500"
        placeholder="Internal note (not visible to lead)..."
        onKeyDown={(e) => { if (e.key === "Enter" && e.ctrlKey) handleSave(); }}
      />
      <div className="mt-2 flex items-center justify-between">
        <span className="text-[10px] text-gray-400">Ctrl+Enter to save</span>
        <button
          onClick={handleSave}
          disabled={!body.trim() || saving}
          className="flex items-center gap-1.5 rounded-lg bg-yellow-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-yellow-600 disabled:opacity-50"
        >
          <Save className="h-3.5 w-3.5" />
          {saving ? "Saving..." : "Save Note"}
        </button>
      </div>
    </div>
  );
}
